import {DomainStore} from 'shared/store';
import {action} from 'mobx';

class ExpenseRequestsContainerState {
  store = new DomainStore();

  @action async removeExpenseRequest(expenseRequest) {
    return this.store.destroy(expenseRequest);
  }
}

export default ExpenseRequestsContainerState;
